import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Related Components
import Enterprise from './pricing/enterprise';
import Grow from './pricing/grow';
import Promo from './pricing/promo';
import LogoutLogo from '../../../agents/subscribe/logout_logo';
import Personal from './pricing/personal';
import Progress from './progress'
import Scale from './pricing/scale';
import TextSwitcher from './text_switcher';

export default class Pricing extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onSubscribe: PropTypes.func.isRequired,
    showProgress: PropTypes.bool,
  }

  static defaultProps = {
    showProgress: true,
  }

  constructor(props) {
    super(props);
    const currentDate = moment();
    const targetDate = moment('2025-04-01');
    const promoActive = currentDate.isBefore(targetDate);

    this.state = {
      promoActive,
      plan: props.user.plan_name || (promoActive ? 'promo' : 'personal'),
      duration: props.user.plan_duration || 'monthly',
    };
  }

  handleSetDuration = (duration) => {
    this.setState({ duration });
  }

  handleSetPlan = (plan) => {
    this.setState({ plan });
  }

  render() {
    const { user, showProgress, onSubscribe } = this.props;
    const { plan, duration, promoActive } = this.state;

    return (
      <div id='pricing'>
        <div className='height-60 margin-bottom-24'>
          <LogoutLogo />
        </div>
        <div className='width-100pct'>
          <div className='width-445 margin-center center-align'>
            {
              showProgress &&
              <div className='margin-bottom-20'>
                <Progress {...{
                  value: 4,
                  max: 4,
                }} />
              </div>
            }
            <div className='pricing width-65 margin-center margin-bottom-15'>
              PRICING
            </div>
            <div className='choose-plan width-445 margin-center height-105 margin-bottom-5'>
              Choose a plan that<br />
              works for you
            </div>
          </div>
          <div className='plan-for-you width-590 margin-center center-align margin-bottom-20'>
            Whether you're just starting out or you're running a major operation,
            Oomple has a plan for you.
          </div>
          <div className='width-265 margin-center relative margin-bottom-10'>
            <TextSwitcher {...{
              value: duration,
              options: [
                { value: 'monthly', text: 'Pay Monthly' },
                { value: 'yearly', text: 'Pay Yearly' },
              ],
              onClick: this.handleSetDuration,
            }} />
            <div className='absolute right--190 top-35'>
              <div className='relative'>
                <img src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/sign_up/arrow.png`} width='200' />
              </div>
            </div>
          </div>
          <div className='no-card-req margin-center center-align margin-bottom-40'>
            No credit card required
          </div>
          <div className='flex flex-row justify-center margin-left-16 margin-right-16 gap-16 flex-wrap'>
            {
              promoActive &&
              <Promo {...{
                user,
                plan,
                duration,
                onSelect: this.handleSetPlan,
                onSetDuration: this.handleSetDuration,
                onSubscribe,
              }} />
            }
            <Personal {...{
              user,
              plan,
              duration,
              onSelect: this.handleSetPlan,
              onSetDuration: this.handleSetDuration,
              onSubscribe,
            }} />
            <Grow {...{
              user,
              plan,
              duration,
              onSelect: this.handleSetPlan,
              onSetDuration: this.handleSetDuration,
              onSubscribe,
            }} />
            <Scale {...{
              user,
              plan,
              duration,
              onSelect: this.handleSetPlan,
              onSetDuration: this.handleSetDuration,
              onSubscribe,
            }} />
            <Enterprise {...{
              user,
              plan,
              duration,
              onSelect: this.handleSetPlan,
              onSetDuration: this.handleSetDuration,
              onSubscribe,
            }} />
          </div>
        </div>
      </div>
    )
  }
}